
  var _styles = {
  "flight-theme-7": {
    "position": "relative",
    "width": "100%"
  },
  "flight-theme-7-container": {
    "position": "relative",
    "width": "100%",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem"
  },
  "flight-theme-7-list": {
    "position": "relative",
    "overflow": "hidden",
    "background": "#fff",
    "width": "100%",
    "borderRadius": "0.32rem"
  },
  "flight-theme-7-list-flight-tag": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "display": "flex",
    "width": "1.38667rem",
    "height": "0.42667rem",
    "justifyContent": "center",
    "alignItems": "center",
    "background": "rgba(255,39,39,.1)",
    "borderRadius": "0.29333rem 0 0.29333rem 0"
  },
  "flight-theme-7-list-tag-text": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem"
  },
  "flight-theme-7-list-flight-img": {
    "position": "absolute",
    "top": "0.04rem",
    "left": "0.04rem"
  },
  "flight-theme-7-list-flight-city": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginTop": "0.46667rem",
    "marginRight": 0,
    "marginBottom": 0,
    "marginLeft": "0.64rem"
  },
  "flight-theme-7-list-flight-city-flight-city-text": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.42667rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0
  },
  "flight-theme-7-list-img": {
    "height": "0.24rem",
    "position": "relative",
    "top": "-0.02667rem",
    "marginLeft": "0.13333rem",
    "marginRight": "0.13333rem"
  },
  "flight-theme-7-list-flight-date": {
    "marginTop": "0.08rem",
    "marginRight": 0,
    "marginBottom": "0.26667rem",
    "marginLeft": "0.64rem",
    "display": "flex"
  },
  "flight-theme-7-list-flight-date-flight-date-text": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "letterSpacing": 0
  },
  "flight-theme-7-list-right": {
    "position": "absolute",
    "right": "0.64rem",
    "top": "0.4rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-end"
  },
  "flight-theme-7-list-right-rmb": {
    "position": "relative",
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.37333rem"
  },
  "flight-theme-7-list-right-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "top": "0.02667rem"
  },
  "flight-theme-7-list-right-num": {
    "marginLeft": "-0.04rem",
    "fontSize": "0.58667rem",
    "color": "rgb(255,75,16)",
    "textAlign": "right",
    "lineHeight": "0.64rem",
    "fontFamily": "MTNewDigitalDisplay-Bold"
  },
  "flight-theme-7-list-right-discount-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,75,16)",
    "borderRadius": "0.08rem",
    "maxWidth": "100%",
    "overflow": "hidden"
  },
  "flight-theme-7-list-right-discount": {
    "height": "0.4rem",
    "padding": "0.06667rem",
    "fontWeight": "500",
    "fontFamily": "MTNewDigitalDisplay-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.26667rem",
    "textAlign": "center"
  },
  "discount-mrn": {
    "lineHeight": "0.30667rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTNewDigitalDisplay-Regular', 'url("https://s3plus.meituan.net/s3plus-specialgroup-hfe/fonts/MTNewDigitalDisplay-Regular.otf") format("opentype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/s3plus-specialgroup-hfe/fonts/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  